<template lang="pug">
div
    div(v-if="data.isOutOfStock")
        div(class="font-bold text-xl text-danger") Product is temporarily unavailable.

    div(v-if="!data.hasMAPViolation")
        div(v-if="data.actualPrice" class="inline-block align-middle font-extrabold text-2xl" :class="{'text-danger':data.basePrice && data.discount, 'text-dark ': !data.discount}")
            span(v-if="data.actualPrice.min") {{ formatCents(data.actualPrice.min) }}
            span(v-if="data.actualPrice.max !== data.actualPrice.min")  - {{ formatCents(data.actualPrice.max) }}

        div(
            v-if="$sitewideData.config.showListPrice && data.basePrice && data.discount"
            class="line-through align-middle"
            :class="{'block':data.basePrice.max !== data.basePrice.min, 'inline-block': data.basePrice.max === data.basePrice.min, 'pl-2': data.basePrice.max === data.basePrice.min}"
        )
            span(v-if="data.basePrice.min" class="align-middle") {{ formatCents(data.basePrice.min) }}
            span(v-if="data.basePrice.max !== data.basePrice.min" class="align-middle")  - {{ formatCents(data.basePrice.max) }}
    div(v-else)
        | Add to cart for sale price
</template>

<script>
import { formatCents } from '@/helpers/filters'

export default {
    name: 'Pricing',
    props: {
        data: {
            required: true,
            type: Object,
        },
    },
    methods: {
        formatCents,
    },
}
</script>
